// StandardLoginForm.jsx
import React, { useState } from "react";
import {
  Typography,
  TextField,
  Button,
  Box,
  InputAdornment,
  CircularProgress,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Cookies from "universal-cookie";
import config from "../../config.js";
const baseURL = config.baseURL;
const StandardLoginForm = ({
  loading,
  setLoading,
  handleForgotPassword,
  onSuccess,
  onError,
  dispatch,
  navigate,
  updateDemo,
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const validateForm = () => {
    let isValid = true;
    setEmailError("");
    setPasswordError("");

    if (!email) {
      setEmailError("Email / Username is required");
      isValid = false;
    }
    if (!password) {
      setPasswordError("Password is required");
      isValid = false;
    }
    return isValid;
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError("");
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setPasswordError("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const userLogin = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    // //console.log("[FRONTEND] Starting login process");
    // //console.log("[FRONTEND] Email:", email);
    // //console.log("[FRONTEND] Password provided:", password ? "Yes" : "No");
    // //console.log("[FRONTEND] Remember me:", rememberMe);

    try {
      // //console.log("[FRONTEND] Making request to:", `${baseURL}/auth/login`);

      const response = await fetch(`${baseURL}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email,
          password,
          RememberMe: rememberMe,
        }),
        credentials: "include",
      });

      //console.log("[FRONTEND] Response status:", response.status);
      //console.log("[FRONTEND] Response ok:", response.ok);
      //console.log(
      //   "[FRONTEND] Response headers:",
      //   Object.fromEntries(response.headers.entries())
      // );

      // Debug: Let's see the raw response text first
      const responseText = await response.text();

      //console.log("[FRONTEND] Raw response text:", responseText);

      let data;

      try {
        data = JSON.parse(responseText);
        //console.log("[FRONTEND] Parsed response data:", data);
      } catch (parseError) {
        //console.error("[FRONTEND] JSON parse error:", parseError);
        throw new Error(
          `Invalid JSON response: ${responseText.substring(0, 200)}`
        );
      }

      if (response.ok) {
        //console.log("[FRONTEND] Login response received:", data);

        // Validate response structure
        if (!data) {
          //console.error("[FRONTEND] No data received in response");
          throw new Error("No data received from server");
        }

        if (!data.tokenuser) {
          //console.error("[FRONTEND] No tokenuser in response:", data);
          throw new Error(
            "Invalid response structure from server - missing tokenuser"
          );
        }

        //console.log("[FRONTEND] Response validation passed");

        const cookies = new Cookies();

        // Store the token
        if (data.token) {
          cookies.set("token", data.token, {
            path: "/",
            secure: true,
            sameSite: "strict",
            expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
          });
          sessionStorage.setItem("authToken", data.token);
          //console.log("[FRONTEND] Token stored successfully");
        } else {
          //console.warn("[FRONTEND] No token received in response");
        }

        // Handle organization logo with better error handling
        // Handle organization logo with direct URL
        let imageUrl = null;
        try {
          const logoLocation = data?.organization?.logoLocation;
          if (logoLocation) {
            imageUrl = `${config.baseURL}/upload/image?fileName=${logoLocation}`;
            //console.log("[FRONTEND] Organization logo URL:", imageUrl);
          }
        } catch (imgErr) {
          //console.warn(
          //   "[FRONTEND] Failed to build organization image URL:",
          //   imgErr
          // );
          imageUrl = null;
        }

        // Dispatch user with proper null checks
        //console.log("[FRONTEND] Dispatching user data");
        if (data.tokenuser) {
          dispatch({
            type: "SET_USER",
            payload: {
              ...data.tokenuser,
              role: data.userRoleWithAccess?.name || "Unknown",
            },
          });
          //console.log("[FRONTEND] User dispatched:", data.tokenuser);
        }

        // Dispatch organization with proper null checks
        if (data.organization) {
          //console.log("[FRONTEND] Dispatching organization data");
          dispatch({
            type: "SET_ORGANIZATION",
            payload: {
              ...data.organization,
              imageBlobUrl: imageUrl,
            },
          });
          //console.log("[FRONTEND] Organization dispatched:", data.organization);
        }

        // Dispatch features with proper null checks
        if (data.userRoleWithAccess?.features) {
          //console.log(
          //   "[FRONTEND] Dispatching features, count:",
          //   data.userRoleWithAccess.features.length
          // );
          dispatch({
            type: "SET_FEATURES",
            payload: data.userRoleWithAccess.features.map((feature) => ({
              action: feature.feature?.action || "",
              api_path: feature.feature?.api_path || "",
              name: feature.feature?.name || "",
              description: feature.feature?.description || "",
              isDefault: feature.feature?.isDefault || false,
              displayName: feature.feature?.displayName || "",
            })),
          });
          //console.log("[FRONTEND] Features dispatched successfully");
        } else {
          //console.warn("[FRONTEND] No features found in response");
          dispatch({
            type: "SET_FEATURES",
            payload: [],
          });
        }

        // Clear form
        setEmail("");
        setPassword("");

        //console.log("[FRONTEND] Login process completed successfully");

        // Wait for state to persist before navigating
        // Wait for state to persist before navigating
        setTimeout(() => {
          onSuccess("Login successful!", {
            ...data.tokenuser,
            organization: data.organization,
          });
        }, 500);
      } else {
        // Handle non-200 responses
        //console.error(
        //   "[FRONTEND] Non-OK response:",
        //   response.status,
        //   response.statusText
        // );
        //console.error("[FRONTEND] Response data:", data);

        let errorMessage = "Backend authentication failed";
        try {
          if (data && (data.message || data.error)) {
            errorMessage = data.message || data.error;
          } else if (data && typeof data === "string") {
            errorMessage = data;
          }
        } catch (parseError) {
          //console.error("[FRONTEND] Error parsing error response:", parseError);
        }

        //console.error("[FRONTEND] Final error message:", errorMessage);
        throw new Error(errorMessage);
      }
    } catch (error) {
      //console.error("[FRONTEND] Login error:", error);

      // Provide more specific error messages
      let userMessage = "Invalid email or password. Please try again.";

      if (error.name === "TypeError" && error.message.includes("fetch")) {
        userMessage =
          "Network error. Please check your connection and try again.";
      } else if (error.message.includes("Invalid response structure")) {
        userMessage =
          "Server response error. Please try again or contact support.";
      } else if (
        error.message &&
        error.message !== "Backend authentication failed"
      ) {
        userMessage = error.message;
      }

      onError(userMessage);
      setEmail("");
      setPassword("");
    } finally {
      setLoading(false);
      // //console.log("[FRONTEND] Login process ended");
    }
  };

  return (
    <form autoComplete="off" onSubmit={userLogin}>
      <Typography variant="h6">Email/Username</Typography>
      <TextField
        id="email"
        placeholder="Type your email or username here"
        type="text"
        variant="outlined"
        fullWidth
        className="form_field"
        autoComplete="new-email"
        error={!!emailError}
        helperText={emailError || " "}
        onChange={handleEmailChange}
        value={email}
        InputProps={{
          sx: {
            borderRadius: "16px",
            border: "2px solid rgba(24, 48, 89, 1)",
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
          },
        }}
      />
      <Typography variant="h6">Password</Typography>
      <TextField
        id="password"
        placeholder="Type your password here"
        variant="outlined"
        type={showPassword ? "text" : "password"}
        fullWidth
        className="form_field"
        error={!!passwordError}
        helperText={passwordError || " "}
        onChange={handlePasswordChange}
        autoComplete="new-password"
        value={password}
        InputProps={{
          endAdornment: (
            <InputAdornment
              position="end"
              className="eye_icon"
              sx={{ cursor: "pointer" }}
            >
              {showPassword ? (
                <VisibilityIcon onClick={togglePasswordVisibility} />
              ) : (
                <VisibilityOffIcon onClick={togglePasswordVisibility} />
              )}
            </InputAdornment>
          ),
          sx: {
            borderRadius: "16px",
            border: "2px solid rgba(24, 48, 89, 1)",
            mb: "10px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
          },
        }}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              sx={{ marginTop: 0, color: "rgba(65, 73, 88, 1)" }}
            />
          }
          label={
            <Typography
              variant="body2"
              sx={{
                color: "rgba(65, 73, 88, 1)",
                fontWeight: "400",
                fontSize: { xs: "16px", sm: "16px" },
                cursor: "pointer",
              }}
              onClick={() => setRememberMe(!rememberMe)}
            >
              Remember me
            </Typography>
          }
        />
        <Typography
          variant="body2"
          sx={{
            cursor: "pointer",
            color: "rgba(32, 168, 224, 1)",
            fontWeight: "400",
            fontSize: { xs: "16px", sm: "16px" },
          }}
          onClick={handleForgotPassword}
        >
          Forgot Password?
        </Typography>
      </Box>
      <Button
        className="customButton_add"
        variant="contained"
        type="submit"
        disabled={loading}
        style={{
          width: "100%",
          borderRadius: "16px",
          marginTop: "40px",
          backgroundColor: "#FFFF00",
          color: "#000000",
          boxShadow: "none",
          height: "56px",
          position: "relative",
        }}
      >
        {loading ? (
          <CircularProgress
            size={28}
            sx={{ color: "#000000", position: "absolute" }}
          />
        ) : (
          <span
            style={{
              textTransform: "none",
              fontWeight: "600",
              fontSize: "32px",
            }}
          >
            Sign in
          </span>
        )}
      </Button>
    </form>
  );
};

export default StandardLoginForm;
